import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import Link from "@src/components/core-link"
const StyledTag = styled.div`
  display: inline-block;
  vertical-align: top;
  font-weight: 500;
  ${props =>
    props.header
      ? css`
          font-size: 14px;
          line-height: normal;
          padding: 3px 10px;
          border-radius: 15px;
        `
      : css`
          font-size: 8px;
          line-height: 10px;
          padding: 2px 5px;
          border-radius: 7px;
        `}

  color: ${props => props.theme.fg2};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 0 ${props => (props.group === "region" ? "1" : "0")} auto;

  background-color: ${props =>
    props.header
      ? props.group === "region"
        ? props.theme.purple
        : props.group === "activity"
        ? props.theme.pastelBlue
        : props.theme.pastelGreen
      : props.group === "region"
      ? props.theme.primary
      : props.group === "activity"
      ? props.theme.orange
      : props.theme.green};

  @media only screen and (${props => props.theme.screen.small.min}) {
    padding: 5px 10px;
    font-size: 12px;
    line-height: 15px;
    border-radius: 12.5px;
  }
`
const StyledLink = styled(Link)`
  display: inline-block;
  z-index: 2;

  & > ${StyledTag}:hover {
    color: ${props => props.theme.black};
  }
`
const Tag = ({ className, group, value, link, header }) => {
  if (!value) {
    return
  }
  const TagItem = (
    <StyledTag className={className} group={group} header={header}>
      {value}
    </StyledTag>
  )
  return link ? <StyledLink to={link}>{TagItem}</StyledLink> : TagItem
}
Tag.propTypes = {
  className: PropTypes.string,
  group: PropTypes.string,
  value: PropTypes.string,
  link: PropTypes.string,
  header: PropTypes.bool,
}
export default Tag
